var _g, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var Svg039Economy = function Svg039Economy(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#039-economy_svg__a)",
    fillRule: "evenodd",
    clipRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.813 9.375a.937.937 0 1 0 0 1.875.937.937 0 0 0 0-1.875ZM0 10.313a2.813 2.813 0 1 1 5.625 0 2.813 2.813 0 0 1-5.625 0Z",
    fill: "#14D64D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 1.875a.937.937 0 1 0 0 1.875.937.937 0 0 0 0-1.875Zm-2.813.938a2.813 2.813 0 1 1 5.626 0 2.813 2.813 0 0 1-5.626 0ZM21.188 5.625a.937.937 0 1 0 0 1.875.937.937 0 0 0 0-1.875Zm-2.813.938a2.813 2.813 0 1 1 5.625 0 2.813 2.813 0 0 1-5.625 0Z",
    fill: "#005454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.875 3.151a.937.937 0 0 1 1.224-.508l5.705 2.356a.938.938 0 0 1-.716 1.733l-5.705-2.357a.938.938 0 0 1-.508-1.224Zm-1.607.247a.938.938 0 0 1-.147 1.318l-3.52 2.816A.938.938 0 0 1 6.43 6.068l3.52-2.816a.938.938 0 0 1 1.318.146Zm7.107 10.665a2.813 2.813 0 0 1 5.625 0v9c0 .517-.42.937-.938.937H.938A.938.938 0 0 1 0 23.062v-5.25a2.813 2.813 0 0 1 5.625 0v4.313h12.75v-8.063Zm1.875 8.062h1.875v-8.063a.938.938 0 0 0-1.875 0v8.063Zm-16.5 0v-4.313a.937.937 0 1 0-1.875 0v4.313H3.75Z",
    fill: "#005454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 9.375a.938.938 0 0 0-.938.938v12.75a.937.937 0 1 1-1.874 0v-12.75a2.813 2.813 0 0 1 5.624 0v12.75a.937.937 0 1 1-1.874 0v-12.75A.938.938 0 0 0 12 9.374Z",
    fill: "#005454"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "039-economy_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
};

export default Svg039Economy;